




















import { Component, Vue } from 'vue-property-decorator'
import UnitDetail from '@/components/UnitDetail.vue'

@Component({
  components: {
    UnitDetail
  }
})
export default class UnitView extends Vue {}
